import SourceOutlinedIcon from "@mui/icons-material/SourceOutlined";
import React from "react";

const Docgen_menus = [
    
    {
        label: 'sidebar.menu.docgen',
        type: "section",
        children: [
            {
                label: 'sidebar.menuItem.docgen_my_forms',
                type: "collapsible",
                icon: <SourceOutlinedIcon sx={{fontSize: 20}}/>,
                children: [
                    {
                        uri: "/docgen/drafts",
                        label: "sidebar.menuItem.docgen_my_drafts",
                        type: "nav-item"
                    },
                    /*{
                        uri: "/docgen/filing",
                        label: "sidebar.menuItem.docgen_ready_for_filing",
                        type: "nav-item"
                    },
                    {
                        uri: "/docgen/ack-awaited",
                        label: "sidebar.menuItem.docgen_awaited",
                        type: "nav-item"
                    },*/
                    {
                        uri: "/docgen/favourites",
                        label: "sidebar.menuItem.docgen_fav",
                        type: "nav-item"
                    },
                    /*{
                        uri: "/docgen/workbench",
                        label: "sidebar.menuItem.docgen_workbench",
                        type: "nav-item"
                    },*/
                    
                ]
            },
            {
                label: 'sidebar.menuItem.docgen_library',
                type: "collapsible",
                icon: <SourceOutlinedIcon sx={{fontSize: 20}}/>,
                children: [
                    {
                        uri: "/docgen/matters",
                        label: 'sidebar.menuItem.docgen_docket',
                        type: "nav-item"
                    },
                    {
                        uri: "/docgen/forms",
                        label: 'sidebar.menuItem.docgen_forms',
                        type: "nav-item"
                    }
                ]
            },
            {

                label: 'sidebar.menuItem.docgen_import',
                type: "collapsible",
                icon: <SourceOutlinedIcon sx={{fontSize: 20}}/>,
                children: [
                    
                            {
                                uri: "/docgen/custom-form",
                                label: 'sidebar.menuItem.docgen_custom_form',
                                type: "nav-item"
                            },
                            {
                                uri: "/docgen/import",
                                label: 'sidebar.menuItem.docgen_import_docket',
                                type: "nav-item"
                            },
                             {
                                uri: "/docgen/categories",
                                label: 'sidebar.menuItem.docgen_category',
                                type: "nav-item"
                            }
                        
                    
                ]
            }
        ]
    },
    
]
   
            

export default Docgen_menus;